import { render, staticRenderFns } from "./PxSelect.vue?vue&type=template&id=3f02d060"
import script from "./PxSelect.vue?vue&type=script&lang=js"
export * from "./PxSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports